module.exports = "/assets/data/a3a616a8805aafa512ffebfb729418dc-KA26.data.json";